import { CheckboxProps } from './Checkbox.types';
import './Checkbox.scss';
import Checkmark from '../../assets/Checkmark.svg?react';
import { FormEvent } from 'react';
export const Checkbox: React.FC<CheckboxProps> = ({
  disabled,
  label,
  isChecked = false,
  onCheck,
  highlighted,
}) => {
  /**
   * Handler method to handle the click
   * @param evt formEvent
   */
  const handleCheck = (evt: FormEvent): void => {
    evt.stopPropagation();
    if (disabled || !onCheck) return;
    onCheck(!isChecked);
  };

  return (
    <div
      data-testid="checkbox-component"
      className="checkbox-component__wrapper"
      onClick={handleCheck}
    >
      {isChecked ? (
        <div className="checkbox-component__checkbox__checked">
          <Checkmark
            className={[
              'checkbox-component__checkbox__checked__checkmark',
              disabled ? 'disabled' : '',
            ].join(' ')}
          />
        </div>
      ) : (
        <div
          className={['checkbox-component__checkbox__empty', disabled ? 'disabled' : ''].join(' ')}
        />
      )}
      {typeof label === 'string' ? (
        <label
          className={['checkbox-component__label', highlighted ? 'highlighted' : ''].join(' ')}
        >
          {label}
        </label>
      ) : (
        label
      )}
    </div>
  );
};
